import React from 'react';
import { connect } from 'react-redux';
import { Col, Jumbotron } from 'react-bootstrap';
import { DownloadButton } from 'ctia-ui';
import { documentDownload } from 'actions/request';

const DocBlock = ({ doc, documentDownload, request }) => {
  return (
    <Col xs={4} key={doc.docId}>
      <Jumbotron className="jumbo-block text-center">
        <h4 className="jumbo-block-header">{doc.title}</h4>
        <DownloadButton
          size="small"
          action={() => documentDownload(doc, request)}
        />
      </Jumbotron>
    </Col>
  );
};

function mapStateToProps({ request }) {
  return { request };
}

export default connect(
  mapStateToProps,
  {
    documentDownload
  }
)(DocBlock);



// WEBPACK FOOTER //
// ./src/components/DocBlock.js